// Animación de carga (spinner)
class HLoading extends HElement {
  template() {
    return `
      <style>
        div {
          --size: ${this.size||'20'}px;
          display: block;
          width: var(--size);
          height: var(--size);
          border: ${this.width||'3'}px solid rgba(var(--color-marca-oscuro3),.7);
          border-right-color: rgb(var(--color-marca-oscuro));
          border-radius: 50%;
          animation: spinner .8s infinite linear;
          margin: auto;
        }
        @keyframes spinner {
          100% {
            transform: rotate(360deg);
          }
        }
      </style>
      <div></div>
    `
  }
}
customElements.define('h-loading', HLoading)

// Tooltip informativo
class HInfoTooltip extends HElement {
  template({ message }) {
    return `
      <style>
        .icon {
          display: block;
          width: 1em;
          height: 1em;
        }
        .info-tooltip {
          position: relative;
        }
        .info-tooltip__modal {
          position: absolute;
          display: block;
          width: calc(50vw - (var(--x-padding) * 2));
          max-width: 290px;
          top: 100%;
          right: 0;
          padding: var(--x-padding);
          background: rgb(var(--color-marca-beis));
          box-shadow: 0 0 20px -10px rgba(0,0,0,.2);
          font: var(--font-body-xs);
          text-align: center;
          opacity: 0;
          pointer-events: none;
        }
        
        .info-wrapper {
          background: transparent;
          border: 0;
          display: inline-block;
          width: fit-content;
          padding-left: 10px;
          padding-right: 0;
        }
        .info-tooltip svg {
          display: block;
        }
        
        .info-tooltip.visible .info-tooltip__modal {
          opacity: 1;
          pointer-events: all;
        }
        
        .info-tooltip__close {
          display: block;
          background: transparent;
          border: 0;
          position: absolute;
          top: var(--y-padding);
          right: var(--y-padding);
        }
      </style>
      <div class="info-tooltip">
        <button class="info-wrapper">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 6C12 7.5913 11.3679 9.11742 10.2426 10.2426C9.11742 11.3679 7.5913 12 6 12C4.4087 12 2.88258 11.3679 1.75736 10.2426C0.632141 9.11742 0 7.5913 0 6C0 4.4087 0.632141 2.88258 1.75736 1.75736C2.88258 0.632141 4.4087 0 6 0C7.5913 0 9.11742 0.632141 10.2426 1.75736C11.3679 2.88258 12 4.4087 12 6ZM4.122 4.52475H4.74075C4.84425 4.52475 4.92675 4.44 4.94025 4.33725C5.00775 3.84525 5.34525 3.48675 5.94675 3.48675C6.46125 3.48675 6.93225 3.744 6.93225 4.36275C6.93225 4.839 6.65175 5.058 6.2085 5.391C5.70375 5.75775 5.304 6.186 5.3325 6.88125L5.33475 7.044C5.33554 7.09321 5.35564 7.14013 5.39072 7.17465C5.4258 7.20916 5.47304 7.22851 5.52225 7.2285H6.1305C6.18023 7.2285 6.22792 7.20875 6.26308 7.17358C6.29825 7.13842 6.318 7.09073 6.318 7.041V6.96225C6.318 6.42375 6.52275 6.267 7.0755 5.84775C7.53225 5.5005 8.0085 5.115 8.0085 4.30575C8.0085 3.1725 7.0515 2.625 6.00375 2.625C5.0535 2.625 4.0125 3.0675 3.94125 4.3395C3.94022 4.36372 3.94416 4.3879 3.95282 4.41054C3.96149 4.43318 3.97469 4.45381 3.99162 4.47116C4.00855 4.48851 4.02885 4.50222 4.05127 4.51143C4.07369 4.52065 4.09776 4.52518 4.122 4.52475ZM5.86575 9.357C6.32325 9.357 6.6375 9.0615 6.6375 8.66175C6.6375 8.24775 6.3225 7.95675 5.86575 7.95675C5.42775 7.95675 5.109 8.24775 5.109 8.66175C5.109 9.0615 5.42775 9.357 5.8665 9.357H5.86575Z" fill="#1A1A1A"/>
          </svg>        
        </button>
        <div class="info-tooltip__modal">
          <button class="info-tooltip__close">
            <svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10.5245 10.8785L10.5245 10.8785L10.5271 10.8809C10.5849 10.9347 10.6345 10.9967 10.6743 11.0647C10.7175 11.1506 10.7297 11.2475 10.7096 11.3388C10.6893 11.4309 10.6374 11.5118 10.5631 11.5678L10.5628 11.568C10.4872 11.6254 10.3929 11.6543 10.2957 11.6492C10.1985 11.6441 10.1046 11.6052 10.0307 11.5387L10.0306 11.5386C10.0012 11.5122 9.97375 11.4846 9.94398 11.4546C9.93623 11.4468 9.92833 11.4388 9.9202 11.4307C7.26448 8.77497 4.60762 6.12022 1.94963 3.46646C1.84031 3.35714 1.77115 3.25643 1.7407 3.15548C1.71252 3.06204 1.71485 2.95962 1.7634 2.83647L1.89756 2.70305C1.92363 2.69721 1.95101 2.69022 1.97605 2.68382C1.99542 2.67887 2.01338 2.67428 2.02824 2.67086C2.07766 2.65951 2.11684 2.65429 2.1512 2.65791C2.18654 2.66163 2.22555 2.67477 2.27132 2.69575C2.3003 2.70903 2.32542 2.72211 2.35245 2.73617C2.37184 2.74627 2.39222 2.75687 2.41569 2.76842L2.45984 2.6787L2.41506 2.76811C2.41835 2.76976 2.42535 2.7746 2.43889 2.78882C2.44454 2.79476 2.45006 2.80092 2.45676 2.8084C2.45787 2.80965 2.45902 2.81092 2.4602 2.81224C2.46797 2.82091 2.4773 2.83124 2.48737 2.84131L2.50307 2.85701L2.51877 2.87271L2.53447 2.88841L2.55017 2.9041L2.56586 2.9198L2.58156 2.9355L2.59726 2.9512L2.61296 2.9669L2.62866 2.98259L2.64435 2.99829L2.66005 3.01399L2.67575 3.02969L2.69145 3.04539L2.70715 3.06108L2.72284 3.07678L2.73854 3.09248L2.75424 3.10818L2.76994 3.12387L2.78564 3.13957L2.80133 3.15527L2.81703 3.17097L2.83273 3.18667L2.84843 3.20236L2.86413 3.21806L2.87982 3.23376L2.89552 3.24946L2.91122 3.26516L2.92692 3.28085L2.94262 3.29655L2.95831 3.31225L2.97401 3.32795L2.98971 3.34365L3.00541 3.35934L3.02111 3.37504L3.0368 3.39074L3.0525 3.40644L3.0682 3.42214L3.0839 3.43783L3.0996 3.45353L3.11529 3.46923L3.13099 3.48493L3.14669 3.50063L3.16239 3.51632L3.17808 3.53202L3.19378 3.54772L3.20948 3.56342L3.22518 3.57912L3.24088 3.59481L3.25657 3.61051L3.27227 3.62621L3.28797 3.64191L3.30367 3.6576L3.31937 3.6733L3.33506 3.689L3.35076 3.7047L3.36646 3.7204L3.38216 3.73609L3.39786 3.75179L3.41355 3.76749L3.42925 3.78319L3.44495 3.79889L3.46065 3.81458L3.47634 3.83028L3.49204 3.84598L3.50774 3.86168L3.52344 3.87738L3.53914 3.89307L3.55483 3.90877L3.57053 3.92447L3.58623 3.94017L3.60193 3.95586L3.61763 3.97156L3.63332 3.98726L3.64902 4.00296L3.66472 4.01866L3.68042 4.03435L3.69611 4.05005L3.71181 4.06575L3.72751 4.08145L3.74321 4.09715L3.75891 4.11284L3.7746 4.12854L3.7903 4.14424L3.806 4.15994L3.8217 4.17563L3.8374 4.19133L3.85309 4.20703L3.86879 4.22273L3.88449 4.23843L3.90019 4.25412L3.91588 4.26982L3.93158 4.28552L3.94728 4.30122L3.96298 4.31691L3.97868 4.33261L3.99437 4.34831L4.01007 4.36401L4.02577 4.37971L4.04147 4.3954L4.05717 4.4111L4.07286 4.4268L4.08856 4.4425L4.10426 4.4582L4.11996 4.47389L4.13565 4.48959L4.15135 4.50529L4.16705 4.52099L4.18275 4.53668L4.19845 4.55238L4.21414 4.56808L4.22984 4.58378L4.24554 4.59948L4.26124 4.61517L4.27693 4.63087L4.29263 4.64657L4.30833 4.66227L4.32403 4.67796L4.33973 4.69366L4.35542 4.70936L4.37112 4.72506L4.38682 4.74076L4.40252 4.75645L4.41821 4.77215L4.43391 4.78785L4.44961 4.80355L4.46531 4.81924L4.48101 4.83494L4.4967 4.85064L4.5124 4.86634L4.5281 4.88204L4.5438 4.89773L4.55949 4.91343L4.57519 4.92913L4.59089 4.94483L4.60659 4.96052L4.62229 4.97622L4.63798 4.99192L4.65368 5.00762L4.66938 5.02332L4.68508 5.03901L4.70077 5.05471L4.71647 5.07041L4.73217 5.08611L4.74787 5.1018L4.76356 5.1175L4.77926 5.1332L4.79496 5.1489L4.81066 5.16459L4.82636 5.18029L4.84205 5.19599L4.85775 5.21169L4.87345 5.22739L4.88915 5.24308L4.90484 5.25878L4.92054 5.27448L4.93624 5.29018L4.95194 5.30587L4.96764 5.32157L4.98333 5.33727L4.99903 5.35297L5.01473 5.36867L5.03043 5.38436L5.04612 5.40006L5.06182 5.41576L5.07752 5.43146L5.09322 5.44715L5.10891 5.46285L5.12461 5.47855L5.14031 5.49425L5.15601 5.50994L5.17171 5.52564L5.1874 5.54134L5.2031 5.55704L5.2188 5.57274L5.2345 5.58843L5.25019 5.60413L5.26589 5.61983L5.28159 5.63553L5.29729 5.65122L5.31298 5.66692L5.32868 5.68262L5.34438 5.69832L5.36008 5.71401L5.37577 5.72971L5.39147 5.74541L5.40717 5.76111L5.42287 5.7768L5.43857 5.7925L5.45426 5.8082L5.46996 5.8239L5.48566 5.8396L5.50136 5.85529L5.51705 5.87099L5.53275 5.88669L5.54845 5.90239L5.56415 5.91808L5.57984 5.93378L5.59554 5.94948L5.61124 5.96518L5.62694 5.98087L5.64263 5.99657L5.65833 6.01227L5.67403 6.02797L5.68973 6.04366L5.70543 6.05936L5.72112 6.07506L5.73682 6.09076L5.75252 6.10646L5.76822 6.12215L5.78391 6.13785L5.79961 6.15355L5.81531 6.16925L5.83101 6.18494L5.8467 6.20064L5.8624 6.21634L5.8781 6.23204L5.8938 6.24773L5.90949 6.26343L5.92519 6.27913L5.94089 6.29483L5.95659 6.31052L5.97228 6.32622L5.98798 6.34192L6.00368 6.35762L6.01938 6.37331L6.03508 6.38901L6.05077 6.40471L6.06647 6.42041L6.08217 6.4361L6.09787 6.4518L6.11356 6.4675L6.12926 6.4832L6.14496 6.49889L6.16066 6.51459L6.17635 6.53029L6.19205 6.54599L6.20775 6.56169L6.22345 6.57738L6.23914 6.59308L6.25484 6.60878L6.27054 6.62448L6.28624 6.64017L6.30193 6.65587L6.31763 6.67157L6.33333 6.68727L6.34903 6.70296L6.36472 6.71866L6.38042 6.73436L6.39612 6.75006L6.41182 6.76575L6.42751 6.78145L6.44321 6.79715L6.45891 6.81285L6.47461 6.82854L6.4903 6.84424L6.506 6.85994L6.5217 6.87564L6.5374 6.89133L6.55309 6.90703L6.56879 6.92273L6.58449 6.93843L6.60019 6.95412L6.61588 6.96982L6.63158 6.98552L6.64728 7.00122L6.66298 7.01691L6.67867 7.03261L6.69437 7.04831L6.71007 7.06401L6.72577 7.0797L6.74146 7.0954L6.75716 7.1111L6.77286 7.1268L6.78856 7.14249L6.80425 7.15819L6.81995 7.17389L6.83565 7.18959L6.85135 7.20528L6.86705 7.22098L6.88274 7.23668L6.89844 7.25238L6.91414 7.26807L6.92984 7.28377L6.94553 7.29947L6.96123 7.31517L6.97693 7.33086L6.99263 7.34656L7.00832 7.36226L7.02402 7.37796L7.03972 7.39365L7.05541 7.40935L7.07111 7.42505L7.08681 7.44075L7.10251 7.45644L7.1182 7.47214L7.1339 7.48784L7.1496 7.50354L7.1653 7.51923L7.18099 7.53493L7.19669 7.55063L7.21239 7.56633L7.22809 7.58202L7.24378 7.59772L7.25948 7.61342L7.27518 7.62912L7.29088 7.64481L7.30657 7.66051L7.32227 7.67621L7.33797 7.69191L7.35367 7.7076L7.36936 7.7233L7.38506 7.739L7.40076 7.7547L7.41646 7.77039L7.43215 7.78609L7.44785 7.80179L7.46355 7.81749L7.47925 7.83318L7.49494 7.84888L7.51064 7.86458L7.52634 7.88028L7.54204 7.89597L7.55773 7.91167L7.57343 7.92737L7.58913 7.94306L7.60483 7.95876L7.62052 7.97446L7.63622 7.99016L7.65192 8.00585L7.66761 8.02155L7.68331 8.03725L7.69901 8.05295L7.71471 8.06864L7.7304 8.08434L7.7461 8.10004L7.7618 8.11574L7.7775 8.13143L7.79319 8.14713L7.80889 8.16283L7.82459 8.17853L7.84029 8.19422L7.85598 8.20992L7.87168 8.22562L7.88738 8.24132L7.90308 8.25701L7.91877 8.27271L7.93447 8.28841L7.95017 8.3041L7.96587 8.3198L7.98156 8.3355L7.99726 8.3512L8.01296 8.36689L8.02865 8.38259L8.04435 8.39829L8.06005 8.41399L8.07575 8.42968L8.09144 8.44538L8.10714 8.46108L8.12284 8.47678L8.13854 8.49247L8.15423 8.50817L8.16993 8.52387L8.18563 8.53957L8.20133 8.55526L8.21702 8.57096L8.23272 8.58666L8.24842 8.60235L8.26412 8.61805L8.27981 8.63375L8.29551 8.64945L8.31121 8.66514L8.3269 8.68084L8.3426 8.69654L8.3583 8.71224L8.374 8.72793L8.38969 8.74363L8.40539 8.75933L8.42109 8.77503L8.43679 8.79072L8.45248 8.80642L8.46818 8.82212L8.48388 8.83781L8.49958 8.85351L8.51527 8.86921L8.53097 8.88491L8.54667 8.9006L8.56236 8.9163L8.57806 8.932L8.59376 8.9477L8.60946 8.96339L8.62515 8.97909L8.64085 8.99479L8.65655 9.01049L8.67225 9.02618L8.68794 9.04188L8.70364 9.05758L8.71934 9.07327L8.73503 9.08897L8.75073 9.10467L8.76643 9.12037L8.78213 9.13606L8.79782 9.15176L8.81352 9.16746L8.82922 9.18316L8.84492 9.19885L8.86061 9.21455L8.87631 9.23025L8.89201 9.24594L8.9077 9.26164L8.9234 9.27734L8.9391 9.29304L8.9548 9.30873L8.97049 9.32443L8.98619 9.34013L9.00189 9.35583L9.01759 9.37152L9.03328 9.38722L9.04898 9.40292L9.06468 9.41861L9.08037 9.43431L9.09607 9.45001L9.11177 9.46571L9.12747 9.4814L9.14316 9.4971L9.15886 9.5128L9.17456 9.52849L9.19025 9.54419L9.20595 9.55989L9.22165 9.57559L9.23735 9.59128L9.25304 9.60698L9.26874 9.62268L9.28444 9.63838L9.30014 9.65407L9.31583 9.66977L9.33153 9.68547L9.34723 9.70116L9.36292 9.71686L9.37862 9.73256L9.39432 9.74826L9.41002 9.76395L9.42571 9.77965L9.44141 9.79535L9.45711 9.81104L9.4728 9.82674L9.4885 9.84244L9.5042 9.85814L9.5199 9.87383L9.53559 9.88953L9.55129 9.90523L9.56699 9.92093L9.58269 9.93662L9.59838 9.95232L9.61408 9.96802L9.62978 9.98371L9.64547 9.99941L9.66117 10.0151L9.67687 10.0308L9.69257 10.0465L9.70826 10.0622L9.72396 10.0779L9.73966 10.0936L9.75535 10.1093L9.77105 10.125L9.78675 10.1407L9.80245 10.1564L9.81814 10.1721L9.83384 10.1878L9.84954 10.2035L9.86523 10.2192L9.88093 10.2349L9.89663 10.2506L9.91233 10.2663L9.92802 10.282L9.94372 10.2977L9.95942 10.3134L9.97511 10.3291L9.99081 10.3447L10.0065 10.3604L10.0222 10.3761L10.0379 10.3918L10.0536 10.4075L10.0693 10.4232L10.085 10.4389L10.1007 10.4546L10.1164 10.4703L10.1321 10.486L10.1478 10.5017L10.1635 10.5174L10.1792 10.5331L10.1949 10.5488L10.2106 10.5645L10.2263 10.5802L10.242 10.5959L10.2577 10.6116L10.2734 10.6273L10.2891 10.643L10.3048 10.6587L10.3205 10.6744L10.3361 10.6901L10.3518 10.7058L10.3675 10.7215L10.3832 10.7372L10.3989 10.7529L10.4146 10.7686L10.4303 10.7843L10.446 10.8L10.4617 10.8157L10.4774 10.8314L10.4931 10.8471L10.5088 10.8628L10.5245 10.8785Z" fill="#1A1A1A" stroke="#1A1A1A" stroke-width="0.2"/>
              <path d="M1.77412 11.3669C1.63045 11.0781 1.70828 10.8468 1.93887 10.6167C4.62393 7.93976 7.30621 5.25929 9.9857 2.57527C10.1924 2.36862 10.4244 2.32495 10.6457 2.44865C10.7096 2.48442 10.7645 2.53384 10.8068 2.59349C10.8491 2.65313 10.8776 2.72159 10.8906 2.79413C10.9035 2.86667 10.9004 2.94156 10.8816 3.01364C10.8628 3.08572 10.8286 3.15326 10.7815 3.21162C10.7367 3.26495 10.6891 3.31589 10.6389 3.3642C7.98641 6.01667 5.33492 8.67013 2.68442 11.3246C2.45475 11.5542 2.22365 11.6495 1.92578 11.5204L1.77412 11.3669Z" fill="#1A1A1A"/>
            </svg>
          </button>
          ${message}
        </div>
      </div>
    `
  }
  mount() {
    const container = this.querySelector('.info-tooltip')
    const button = this.querySelector('.info-tooltip__close')
    const trigger = this.querySelector('.info-wrapper')

    button.addEventListener('click', e => {
      button.blur()
      container.classList.remove('visible')
    })
    if(innerWidth > 750) {
      container.addEventListener('mouseenter', e => {
        if(e.target !== container) return
        container.classList.add('visible')
      })
      container.addEventListener('mouseleave', e => {
        if(e.target !== container) return
        container.classList.remove('visible')
      })
    } else {
      trigger.addEventListener('click', e => {
        container.classList.add('visible')
      })
    }
  }
}
customElements.define('h-info-tooltip', HInfoTooltip)

// Botones
class HButton extends HTMLElement {
  constructor() {
    super();
    const {mode, skin} = HElement.GetAttributes(this)
    this.attachShadow({mode: 'open'})
    this.shadowRoot.innerHTML = `
    <style>
      button {
        display: block;
        padding: var(--y-padding--button) var(--x-padding--button);
        background: rgb(var(--color-marca-salmon));
        border: 0;
        border-radius: var(--radius--button);
        font-size: var(--fs-xs);
        font-weight: bold;
        cursor: pointer;
      }
      button.mode-small {
        padding: var(--padding);
      }
      button.mode-full-width {
        width: 100%;
      }
      button.skin-dark {
        background: rgb(var(--color-marca-oscuro));
        color: rgb(var(--color-marca-claro));
      }
    </style>
    <button class="mode-${mode} skin-${skin}"><slot></slot></button>`
  }
}
customElements.define('h-button',HButton)

// Toggle
class HToggle extends HReactiveElement {
  checked = false
  constructor() {
    super();
    this.makeState('checked',this.checked)
    this.shadowRoot.addEventListener('click', e => {
      this.checked = !this.checked
      this.dispatchEvent(new CustomEvent('change',{bubbles: true}))
    })
  }
  template({checked}) {
    return `
      <style>
        .h-toggle {
          display: flex;
          align-items: center;
          gap: 5px;
          cursor: pointer;
        }
        .h-toggle-button {
          --size: 12px;
          display: flex;
          background: rgb(var(--color-marca-beis));
          border: 2px solid rgb(var(--color-marca-beis));
          border-radius: var(--size);
          width: calc(var(--size) * 2.5);
          padding: 0;
        }
        .h-toggle-button:before {
          content: "";
          display: block;
          width: var(--size);
          height: var(--size);
          border-radius: 50%;
          background: rgb(var(--color-marca-oscuro3));
          transition: all .2s;
          margin-left: 0;
        }
        .h-toggle-button.checked:before {
          margin-left: calc(100% - var(--size));
          background: rgb(var(--color-marca-rebajas));
        }
      </style>
      <div class="h-toggle">
        <button class="h-toggle-button ${checked?'checked':''}"></button>
        <slot></slot>
      </div>
    `
  }
  mount(params) {
    super.mount(params)
    this.button = this.shadowRoot.querySelector('.h-toggle-button')
  }
  onUpdate({checked}) {
    this.button.classList.toggle('checked', checked)
  }
}
customElements.define('h-toggle', HToggle)